import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/authContext';
import { FaBars } from 'react-icons/fa';

const TopBarContainer = styled.div`
  height: 60px;
  background-color: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1001;

  @media (max-width: 768px) {
    padding: 0 15px;
  }

  @media (max-width: 480px) {
    padding: 0 10px;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  @media (max-width: 480px) {
    gap: 10px;
  }
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 8px;
  color: white;
  border-radius: 4px;
  transition: background-color 0.2s;
  display: block; /* Всегда показываем кнопку */

  &:hover {
    background-color: #2d5016;
  }

  &:active {
    background-color: #2d5016;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    padding: 6px;
  }
`;

const Title = styled.div`
  color: white;
  font-weight: bold;
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const LogoutButton = styled.button`
  background-color: transparent;
  border: none;
  color: white;
  font-weight: bold;
  cursor: pointer;
  font-size: 16px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #2d5016;
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 6px 10px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    padding: 5px 8px;
  }
`;

function TopBar({ onMenuClick }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <TopBarContainer>
      <LeftSection>
        <MenuButton onClick={onMenuClick}>
          <FaBars />
        </MenuButton>
        <Title>Управление сайтом</Title>
      </LeftSection>
      <LogoutButton onClick={handleLogout}>Выйти</LogoutButton>
    </TopBarContainer>
  );
}

export default TopBar;